var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKnowledgeBaseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8125 15.0664L11 17.7734L6.1875 15.0664V12.2063L4.8125 11.4424V15.8705L11 19.351L17.1875 15.8705V11.4424L15.8125 12.2063V15.0664Z",
    fill: "#3D4C66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 1.97559L1.375 6.96632V8.15802L11 13.5051L19.25 8.92191V12.7188H20.625V6.96632L11 1.97559ZM17.875 8.11285L16.5 8.87671L11 11.9324L5.5 8.87671L4.125 8.11285L3.172 7.58339L11 3.52444L18.828 7.58339L17.875 8.11285Z",
    fill: "#3D4C66"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledgeBaseIcon);
export default __webpack_public_path__ + "static/media/knowledgeBase-Icon.842f7876bd47e3ac0b7f89d7122468a1.svg";
export { ForwardRef as ReactComponent };